import React, { useState, useContext, useReducer } from "react";
import GlobalContext    from "../../isp._comun/iu/contexto/GlobalContext";
import ComandoAPI       from "../../isp._comun/iu/componentes/ComandoAPI";
import * as TipoDeError from "../../isp._comun/services/Errores";

import ServiceQueryContratos from "../../isp.žapi.contratos/ServiceQueryContratos";

import QueryContratoReducer         from "../reductores/QueryContratoReducer";
import CargaDeContratosBuscados from "../reductores/acciones/dispatch/CargaDeContratosBuscados";
import FinalizarComando         from "../reductores/acciones/dispatch/FinalizarComando";


import DialogoQueryContratosLayout from "./layouts/DialogoQueryContratosLayout";

const DialogoQueryContratos = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryContratoReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });

    // const buscarServiciosCommand = new ComandoBuscarServicios();
    // const buscarServiciosCommand = new ComandoBuscarServicios();
    const ServicioApiQueryServicios = new ServiceQueryContratos();
    const buscarServiciosCommand = new ComandoAPI(ServicioApiQueryServicios);
    buscarServiciosCommand.ejecutar = async (paramsQuery) => {
    // buscarServiciosCommand.ejecutar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
    // buscarServiciosCommand.ejecutar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
    // const buscarItems = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
        /* const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        }; */

        try {
            const respuestaQuery = await ServicioApiQueryServicios.ejecutar(paramsQuery);
            /* const respuestaQuery = await new ServicioDeQueryDeClientesAFacturar().ejecutar(
            /* const respuestaQuery = await new ServicioDeQueryDeClientesAFacturar().ejecutar(
                paramsQuery
            ); */
            // dispatchQ(new CargaDeItemsBuscados(respuestaQuery.clientes));
            dispatchQ(new CargaDeContratosBuscados(respuestaQuery.items));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
            // throw error;
        }
    }
    // });

    

    return (
        <DialogoQueryContratosLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarItems={buscarServiciosCommand}
            // buscarItems={buscarItems}

        />
    );
};

export default DialogoQueryContratos;
